import Parser from './parser.js'
import Executor from './executor.js'

export default class {
  constructor () {
    this.plugins = {}

    // intialize jet.js itself
    this.parser = new Parser()
    this.el = this.parser.findSelf('[data-jetjs=true]')
    this.opts = this.parser.readOptions(this.el, 'jetjs', {
      /*
       * namespace for data attributes (default = jetjs)
       */
      namespace: 'jetjs',

      /*
       * [data-jetjs-run] can be one of the following values:
       * true => runs immediately (make sure, to include jetjs at the bottom of your body tag. DOM Elements must be availble.)
       * false => jet.js does not run. Use API methods (#run or #searchAndRun) to execute plugins later
       * {String - Eventname} => Eventname that should be listened for via window#addEventListener(Eventname):
       *    default = false (will be DOMContentLoaded in the future)
       *  more information here: https://eager.io/blog/how-to-decide-when-your-code-should-run/
       */
      run: 'false'
    })

    // find elements with plugin definitions
    this.executor = new Executor(this.opts.namespace, this.parser)

    // run jetjs (if needed)
    if (this.opts.run === 'true') {
      this.searchAndRun(document.body)
    } else if (this.opts.run !== 'false') {
      window.addEventListener(this.opts.run, () => {
        this.searchAndRun(document.body)
      })
    }

    // To allow other Executors, they should extend the given Executor class
    // and overwrite its executePlugin Method.
    //
    // e.g. jQueryExecutor extends Executor {
    //    executePlugin(element, plugin, pipedValue) {
    //      // read options from this.parser and execute $.fn[plugin.name].apply(element, opts)
    //    }
    // }
  }

  /**
   * it parses and executes all plugins on the given elements
   * @param element Array of elements (or single Element) to search for plugins and execute them.
   *                Every Element should contain plugin definitons. No search or filtering is done.
   */
  run (elements) {
    // if length is not defined, it is a single element and so it should be executed
    // but if length is equal zero it is an empty nodelist and must not be executed
    if (elements.length !== 0) {
      this.executor.executeAll([].concat(elements))
    }
  }

  /**
   * Searches for children with plugin definitions and executes them.
   * Helpful to executes plugins on lazy loaded markup.
   * @param element element to use as starting point to search for elements with plugin definitions.
   */
  searchAndRun (element) {
    const nodes = this.parser.findAllBelow(element, `[data-${this.opts.namespace}-plugin],[data-${this.opts.namespace}-plugins]`)
    this.run(Array.prototype.slice.call(nodes))
  }
}
